<template>
  <el-menu
    class="menus_wrap"
    text-color="#333"
    :default-active="$route.meta.id ? $route.meta.id.toString() : ''"
    active-text-color="#4e70f2"
	:unique-opened="true"
  >
    <menu-item :data="data" @change="changes" :editNameObj="editNameObj" :needCircleObj="waitCountObj"></menu-item>
  </el-menu>
</template>

<script>
import menuItem from './menu-item'
import {mapState, mapActions } from 'vuex'
export default {
	props: {
		data: {
			type: Array,
			default: () => []
    	},
		editNameObj: {
			type: Object,
			default: () => {
				return {
					path: 'path',
					title: 'title',
					src: 'src'
				}
			}
		}
  	},
	created() {
		this.waitCount()
		console.log('sddddsds')
	},
	computed: {
		...mapState('message',['waitCountObj'])
	},
	components: {
	    'menu-item': menuItem
	},
	methods: {
		...mapActions('message', ['waitCount']),
		changes(item) {
			this.$emit('change', item)
		}
	}
}
</script>

<style lang="less">
	.menus_wrap {
		width: 190px;
		height: 100%;
		border-right:none;
	}
</style>
